import http from './api'

const route = 'app/comercial/pedidos/'

export default {
  showPedidosDiaADia: (dataInicial, dataFinal, select, receita, tokenContrato, rede, categoria, promotor, vendedor) => {
    return http.post(route + 'showPedidosDiaADia', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      select: select,
      receita: receita,
      tokenContrato: tokenContrato,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      vendedor: vendedor,
    })
  },

  showPedidosAbertoNoMeses: (dataInicial, dataFinal, select, receita, tokenContrato, rede, categoria, promotor, vendedor) => {
    return http.post(route + 'showPedidosAbertoNoMeses', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      select: select,
      receita: receita,
      tokenContrato: tokenContrato,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      vendedor: vendedor,
    })
  },

  showEnableDadosPedidos: (dia, status, select, receita, tokenContrato, rede, categoria, promotor, vendedor) => {
    return http.post(route + 'showEnableDadosPedidos', {
      dia: dia,
      status: status,
      select: select,
      receita: receita,
      tokenContrato: tokenContrato,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      vendedor: vendedor,
    })
  },

  showEnableDadosPedidosMes: (dia, status, select, receita, tokenContrato, rede, categoria, promotor, vendedor) => {
    return http.post(route + 'showEnableDadosPedidosMes', {
      dia: dia,
      status: status,
      select: select,
      receita: receita,
      tokenContrato: tokenContrato,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      vendedor: vendedor,
    })
  },
  showPedidosLista (username, tokenContrato, dataInicial, dataFinal, select, receita, rede, categoria, promotor, vendedor) {
    return http.post(route + 'showPedidosLista', {
      username, tokenContrato, dataInicial, dataFinal, select, receita, rede, categoria, promotor, vendedor,
    })
  },
  showPedidoLocalizacao (username, tokenContrato, numpedido, nomeBd) {
    return http.post(route + 'showPedidoLocalizacao', {
      username, tokenContrato, numpedido, nomeBd,
    })
  },
}
